<template>
    <div class="form-element__container" :id="fullFormIdentifier + '-container'">
        <textarea
            :id="fullFormIdentifier"
            v-model="internalValue"
            :class="{ 'form-element__textarea--active': isFilled }"
            class="form-element__textarea"
            :name="inputName"
            :data-validate="validation"
            :data-validate-message="validationMessage"
            :data-error-target="fullFormIdentifier + '-container'"
            autocomplete="off"
            :placeholder="inputTitle"
        />
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                default: null,
                required: false,
            },
            formIdentifier: {
                type: String,
                default: "form",
            },
            inputName: {
                type: String,
                default: "",
            },
            inputTitle: {
                type: String,
                required: true,
            },
            inputValidate: {
                type: Boolean,
            },
            inputValidateMessage: {
                type: String,
                default: "",
            },
        },
        data() {
            return {
                internalValue: null,
            };
        },
        created() {
            this.internalValue = this.value;
        },
        watch: {
            internalValue: function(newValue) {
                this.$emit('input', newValue);
            },
            value: function(newValue) {
                this.internalValue = newValue;
            }
        },
        computed: {
            isFilled() {
                if (this.internalValue == null) {
                    return false;
                }

                if (this.internalValue == '') {
                    return false;
                }

                return true;
            },
            validation() {
                if (this.inputValidate) {
                    return "input";
                }
                return false;
            },
            validationMessage() {
                if (this.inputValidateMessage) {
                    return this.inputValidateMessage;
                }
                return false;
            },
            fullFormIdentifier() {
                return this.formIdentifier + "-" + this._uid;
            },
        },
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Forms/redesign/GenericTextarea.vue